export const transparentPanelSx = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
} as const;

export const listCardSx = {
  px: 2,
  borderRadius: 2,
  '@media (hover: hover)': {
    '&:hover': {
      backgroundColor: 'highlight.actionable',
    },
  },
} as const;
